import { init as initVideoSection } from "../sections/video";

export function init() {
  /* Video (self-hosted) with controls */
  const pageVideoSections = Array.from(
    document.querySelectorAll(".shopify-section.video")
  );
  for (let section of pageVideoSections) {
    if (section instanceof HTMLElement) {
      initVideoSection(section);
    }
  }
}
